import { TableCellsIcon } from '@heroicons/react/16/solid';
import { Button } from 'react-daisyui';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export default function NoTemplates() {
  const { t } = useTranslation('chat/chat');
  const navigate = useNavigate();

  return (
    <div className="flex flex-col w-full p-4 bg-base-100 rounded-sm">
      <div className="flex flex-row border-dashed border-2 justify-center px-72 py-12">
        <div className="flex flex-col text-center">
          <img
            src={'/images/agenda/calendar.icon.png'}
            alt="calendar"
            className="w-20 h-20 mx-auto mb-4 "
          />

          <div className="flex flex-row justify-center mt-4">
            <Button
              color="primary"
              startIcon={<TableCellsIcon className="w-6 h-6" />}
              onClick={() => {
                navigate('/agenda?tab=templates');
              }}
            >
              {t('agendaAction.createTemplate')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
